import { useState, useCallback } from "react";

const useCartModal = () => {
  const [isCartOpen, setIsCartOpen] = useState(false);

  const openCart = useCallback(() => setIsCartOpen(true), []);
  const closeCart = useCallback(() => setIsCartOpen(false), []);
  const toggleCart = useCallback(() => setIsCartOpen((prev) => !prev), []);

  return { isCartOpen, openCart, closeCart, toggleCart };
};

export default useCartModal;